import { useEffect, useState } from 'react';
import { Form, Modal, Input, Select, Switch, Upload, InputNumber } from 'antd';
import { listScenes } from '@/services/addApp';
import { wrapperUrlWithPrefix } from '@/utils/utils';
import './index.less';
import { Upload as UploadIcon } from 'patternx-svg';
import upload from '@/utils/uploadFile';

/**
 * 独立小程序
 */
const AppIndependentModal = (props: any) => {
  const { visible, title, onHandleCancel, onHandleSubmit, data, appType } = props;
  const appData = {
    ...data,
    validationFile: data.validationFile ? JSON.parse(data.validationFile) : [],
    privateKeyFile: data.privateKeyFile ? JSON.parse(data.privateKeyFile) : [],
    alarmVerifyPhoneUsageLtThreshold: data.wxPhoneVerifyUsageAlarm
      ? JSON.parse(data.wxPhoneVerifyUsageAlarm)?.ltThreshold
      : null,
    alarmVerifyPhoneUsageLtDays: data.wxPhoneVerifyUsageAlarm
      ? JSON.parse(data.wxPhoneVerifyUsageAlarm)?.ltDays
      : null,
  };
  const [form] = Form.useForm();
  const [sceneOptions, setSceneOptions] = useState<any>([]);
  const [validationFile, setValidationFile] = useState('');
  const [privateKeyFile, setPrivateKeyFile] = useState('');
  const [enableWxLogin, setEnableWxLogin] = useState<boolean>(data.enableWxLogin || false);

  // 获取场景枚举值
  const getScenes = async () => {
    const scenesList = await listScenes();
    setSceneOptions(scenesList);
  };

  useEffect(() => {
    if (data.validationFile && data.validationFile !== '[]') {
      setValidationFile(data.validationFile);
    }
    if (data.privateKeyFile && data.privateKeyFile !== '[]') {
      setPrivateKeyFile(data.privateKeyFile);
    }
    getScenes();
  }, []);

  const handleSubmit = () => {
    form.validateFields().then(async (values) => {
      onHandleSubmit({
        ...values,
        type: appType,
        id: data?.id,
        validationFile: Array.isArray(values.validationFile)
          ? JSON.stringify(values.validationFile)
          : validationFile,
        privateKeyFile: Array.isArray(values.privateKeyFile)
          ? JSON.stringify(values.privateKeyFile)
          : privateKeyFile,
        wxPhoneVerifyUsageAlarm: {
          ltThreshold: values.alarmVerifyPhoneUsageLtThreshold,
          ltDays: values.alarmVerifyPhoneUsageLtDays,
        },
      });
    });
  };

  const handleCancel = () => onHandleCancel();

  const onValidateFileChange = ({ file }: any) => {
    if (file?.response && file.response.code === 'SUCCESS') {
      setValidationFile(file.response.details);
    }
  };

  const onPrivateKeyFileChange = ({ file }: any) => {
    if (file?.response && file.response.code === 'SUCCESS') {
      setPrivateKeyFile(file.response.details);
    }
  };

  const normFile = (e: any) => {
    if (Array.isArray(e)) {
      return e;
    }
    return e?.fileList.map((item: any) => {
      return { name: item.name, uid: item.uid };
    });
  };

  return (
    <Modal
      title={title}
      visible={visible}
      onCancel={handleCancel}
      onOk={handleSubmit}
      maskClosable={false}
      width={800}
    >
      <Form
        name="basic"
        autoComplete="off"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 14 }}
        form={form}
        className="app-modal"
        initialValues={appData}
      >
        <Form.Item
          label="场景"
          name="sceneCode"
          rules={[{ required: true, message: '请选择场景' }]}
        >
          <Select
            showSearch
            placeholder="请选择场景"
            optionFilterProp="children"
            filterOption={(input: string, option: any) =>
              (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
            }
            options={sceneOptions}
          />
        </Form.Item>

        <Form.Item
          label="应用名称"
          name="appName"
          rules={[{ required: true, message: '请输入应用名称' }]}
        >
          <Input placeholder="输入应用名称" />
        </Form.Item>
        <Form.Item label="APPID" name="appId" rules={[{ required: true, message: '请输入APPID' }]}>
          <Input placeholder="输入APPID" />
        </Form.Item>
        <Form.Item
          label="appSecret"
          name="appSecret"
          rules={[{ required: true, message: '请输入appSecret' }]}
        >
          <Input placeholder="输入appSecret" />
        </Form.Item>

        <Form.Item
          label="域名验证文件"
          name="validationFile"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            key="uploadValidate"
            name="file"
            accept=".txt"
            action={`${wrapperUrlWithPrefix('/account/v1/mpApp/file')}`}
            listType="text"
            onChange={onValidateFileChange}
            customRequest={upload}
          >
            <div className={`uploadBtn`}>
              <UploadIcon size={20} className="uploadIcon" />
              点击上传
            </div>
          </Upload>
        </Form.Item>
        <Form.Item
          label="小程序代码上传密钥"
          name="privateKeyFile"
          valuePropName="fileList"
          getValueFromEvent={normFile}
        >
          <Upload
            key="uploadPrivateKey"
            name="file"
            accept=".key"
            action={`${wrapperUrlWithPrefix('/account/v1/mpApp/file')}`}
            listType="text"
            onChange={onPrivateKeyFileChange}
            customRequest={upload}
          >
            <div className={`uploadBtn`}>
              <UploadIcon size={20} className="uploadIcon" />
              点击上传
            </div>
          </Upload>
        </Form.Item>
        <Form.Item label="服务商票据" name="wxServiceProviderTicket">
          <Input placeholder="服务商票据" />
        </Form.Item>

        <Form.Item label="启用微信二维码接口" name="enableWxGetUnlimitedQrcodeApi">
          <Switch
            checkedChildren="开启"
            unCheckedChildren="关闭"
            defaultChecked={appData.enableWxGetUnlimitedQrcodeApi}
          />
        </Form.Item>
        <Form.Item label="启用微信授权登录" name="enableWxLogin">
          <Switch
            checkedChildren="开启"
            unCheckedChildren="关闭"
            defaultChecked={appData.enableWxLogin}
            onChange={(e) => setEnableWxLogin(e)}
          />
        </Form.Item>
        {enableWxLogin && (
          <>
            <Form.Item
              name="alarmVerifyPhoneUsageLtThreshold"
              label="用量低于多少次时告警阈值"
              tooltip="当手机快速验证功能资源包在剩余使用量少于多少次时进行告警提醒"
            >
              <InputNumber style={{ width: '200px' }} min={0} maxLength={20} />
            </Form.Item>
            <Form.Item
              name="alarmVerifyPhoneUsageLtDays"
              label="过期前几天时告警阈值"
              tooltip="当手机快速验证功能资源包在有效日期前多少天时进行告警提醒"
            >
              <InputNumber style={{ width: '200px' }} min={0} maxLength={20} />
            </Form.Item>
          </>
        )}

        <Form.Item label="启用调试模式" name="enableDebugMode">
          <Switch
            checkedChildren="开启"
            unCheckedChildren="关闭"
            defaultChecked={appData.enableDebugMode}
          />
        </Form.Item>
      </Form>
    </Modal>
  );
};
export default AppIndependentModal;
